export const INITIALIZE_PAYMENT_CARD = 'INITIALIZE_PAYMENT_CARD';
export const INITIALIZE_PAYMENT_CARD_PENDING = 'INITIALIZE_PAYMENT_CARD_PENDING';
export const INITIALIZE_PAYMENT_CARD_ERROR = 'INITIALIZE_PAYMENT_CARD_ERROR';
export const CREATE_PAYMENT_CARD = 'CREATE_PAYMENT_CARD';
export const ACTIVATE_3DSECURE = 'ACTIVATE_3DSECURE';
export const CREATE_PAYMENT_CARD_PENDING = 'CREATE_PAYMENT_CARD_PENDING';
export const CREATE_PAYMENT_CARD_ERROR = 'CREATE_PAYMENT_CARD_ERROR';
export const DELETE_PAYMENT_CARD_FULFILLED = 'DELETE_PAYMENT_CARD_FULFILLED';
export const DELETE_PAYMENT_CARD_PENDING = 'DELETE_PAYMENT_CARD_PENDING';
export const DELETE_PAYMENT_CARD_ERROR = 'DELETE_PAYMENT_CARD_ERROR';
export const PAYMENT_PENDING = 'PAYMENT_PENDING';
export const PAYMENT_FULFILLED = 'PAYMENT_FULFILLED';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const GET_USES_NEW_FLOW = 'GET_USES_NEW_FLOW'; // checks if account uses new payment flow
export const GET_USES_NEW_FLOW_PENDING = 'GET_USES_NEW_FLOW_PENDING';
export const GET_USES_NEW_FLOW_ERROR = 'GET_USES_NEW_FLOW_ERROR';
